import { render, staticRenderFns } from "./brandProduct.vue?vue&type=template&id=28906d22&scoped=true"
import script from "./brandProduct.vue?vue&type=script&lang=js"
export * from "./brandProduct.vue?vue&type=script&lang=js"
import style0 from "./brandProduct.vue?vue&type=style&index=0&id=28906d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28906d22",
  null
  
)

export default component.exports